import { ShippingWay } from "@/services/api/orderShip";

function get(key: any) {
    return localStorage.getItem(key);
}

function set(key: any, value: any) {
    return localStorage.setItem(key, value);
}

function remove(key: string) {
    return localStorage.removeItem(key);
}

function getInt(key: any) {
    return parseInt(get(key), 10);
}

const DEFAULT_WAYBILL_TEMPLATE_KEY = "default-waybill-template";

const LAST_USED_WAYBILL_TEMPLATE_KEY = "last-used-waybill-template";

const WAYBILL_PRINTER_KEY_PREFIX = "waybill-printer-";

const SHIPPING_ADDRESS_KEY_PREFIX = "waybill-shipping-address-";

// 默认发货单模板
const DEFAULT_PACKING_LIST_TEMPLATE_KEY = "default-packing-list-template";

// 默认商品标签模板
const DEFAULT_ORDER_ITEM_LABEL_TEMPLATE_KEY = "default-order-item-label-template";

// 发货单打印
const PACKING_LIST_PRINTER_KEY_PREFIX = "packing-list-printer-";

// 订单商品标签
const ORDER_ITEM_LABEL_PRINTER_KEY_PREFIX = "order-item-label-printer-";

const PRODUCT_LABEL_PRINTER_KEY = "product-label-printer";

const LAST_PRODUCT_LABEL_TEMPLATE_KEY = "last-product-label-template";

// 发货方式
const SHIPPING_WAY_KEY = "shipping-way-";

const SHIP_EASY_TOKEN = "ship-easy-token";

// 登录视角
const LOGIN_VIEW = "login_view";

//
const SHORTCUT = "shortcut";

export const LAST_TEMPLATE_ID_PREFIX = "__LAST_TEMPLATE_ID_PREFIX__";

const CLIENT_IP = "__CLIENT_IP__";

/**
 * 本地缓存管理器
 */
class StorageManager {
    static get shippingWay() {
        return get(SHIPPING_WAY_KEY) as ShippingWay;
    }

    static set shippingWay(value) {
        set(SHIPPING_WAY_KEY, value);
    }

    static getDefaultWaybillTemplate() {
        return getInt(DEFAULT_WAYBILL_TEMPLATE_KEY);
    }

    static setDefaultWaybillTemplate(templateId: any) {
        set(DEFAULT_WAYBILL_TEMPLATE_KEY, templateId);
    }

    static getWaybillPrinter(templateId: any) {
        return get(WAYBILL_PRINTER_KEY_PREFIX + templateId);
    }

    static setWaybillPrinter(templateId: any, printerName: any) {
        set(WAYBILL_PRINTER_KEY_PREFIX + templateId, printerName);
    }

    static getDefaultPackingListTemplate() {
        return getInt(DEFAULT_PACKING_LIST_TEMPLATE_KEY);
    }

    static setDefaultPackingListTemplate(templateId: any) {
        set(DEFAULT_PACKING_LIST_TEMPLATE_KEY, templateId);
    }

    static getLastUsedWaybillTemplate() {
        return getInt(LAST_USED_WAYBILL_TEMPLATE_KEY);
    }

    static setLastUsedWaybillTemplate(templateId: any) {
        set(LAST_USED_WAYBILL_TEMPLATE_KEY, templateId);
    }

    /**
     * 获取发货单打印机
     * @returns {string} name of printer
     */
    static getPackingListPrinter(templateId: any) {
        return get(PACKING_LIST_PRINTER_KEY_PREFIX + templateId);
    }

    static setPackingListPrinter(templateId: any, printerName: any) {
        set(PACKING_LIST_PRINTER_KEY_PREFIX + templateId, printerName);
    }

    /**
     * 获取商品标签打印机
     * @returns {string} name of printer
     */
    static getOrderItemLabelPrinter(templateId: any) {
        return get(ORDER_ITEM_LABEL_PRINTER_KEY_PREFIX + templateId);
    }

    static setOrderItemLabelPrinter(templateId: any, printerName: any) {
        set(ORDER_ITEM_LABEL_PRINTER_KEY_PREFIX + templateId, printerName);
    }

    static getDefaultOrderItemLabelTemplate() {
        return getInt(DEFAULT_ORDER_ITEM_LABEL_TEMPLATE_KEY);
    }

    static setDefaultOrderItemLabelTemplate(templateId: any) {
        set(DEFAULT_ORDER_ITEM_LABEL_TEMPLATE_KEY, templateId);
    }

    static getProductLabelPrinter() {
        return get(PRODUCT_LABEL_PRINTER_KEY);
    }

    static setProductLabelPrinter(printerName: string) {
        set(PRODUCT_LABEL_PRINTER_KEY, printerName);
    }

    static getLastProductLabelTemplate() {
        return getInt(LAST_PRODUCT_LABEL_TEMPLATE_KEY);
    }

    static setLastProductLabelTemplate(templateId: number) {
        set(LAST_PRODUCT_LABEL_TEMPLATE_KEY, templateId);
    }

    static getToken() {
        return get(SHIP_EASY_TOKEN);
    }

    static removeToken() {
        return remove(SHIP_EASY_TOKEN);
    }

    static getLoginView() {
        return get(LOGIN_VIEW);
    }

    static setLoginView(role: "supplier" | "retailer") {
        return set(LOGIN_VIEW, role);
    }

    static getShortcut() {
        return get(SHORTCUT);
    }

    static setShortcut(value: "load" | "unload") {
        set(SHORTCUT, value);
    }

    static getLastWaybillTemplateId(name: number | string) {
        return getInt(LAST_TEMPLATE_ID_PREFIX + name.toString());
    }

    static setLastWaybillTemplateId(name: number | string, waybillTemplateId) {
        return set(LAST_TEMPLATE_ID_PREFIX + name.toString(), waybillTemplateId);
    }

    static getIPCache() {
        const itemStr = localStorage.getItem(CLIENT_IP);
        if (!itemStr) {
            return null;
        }

        try {
            const now = new Date();
            const cache = JSON.parse(itemStr);

            // 检查是否过期
            if (now.getTime() > cache.expiry) {
                remove(CLIENT_IP);

                return null;
            }

            return cache.value as string;
        } catch {}

        return null;
    }

    static setIPCache(ip: string) {
        const now = new Date();
        const ipCache = {
            value: ip,
            expiry: now.getTime() + 24 * 60 * 60 * 1000, // 24 小时有效时间
        };

        set(CLIENT_IP, JSON.stringify(ipCache));
    }
}

export default StorageManager;
